export const FPLoader = () => {
  const logoutRefresh=()=>{
    document.cookie='';
    window.location.reload();
  }
  return (
    <div className={'flex h-full min-h-screen w-full items-center justify-center'}>
      <img src={'/apple-icon.png'} alt={'logo'} className={'h-24 w-24'} />
      <p onClick={logoutRefresh} className='underline'>logout</p>
      
    </div>
  );
};
